const ALLOWED_SCHEMES = ['http:', 'https:', 'ftp:', 'ftps:'];

const IPV4_OCTET = '(?:0|25[0-5]|2[0-4][0-9]|1[0-9]?[0-9]?|[1-9][0-9]?)';
const IPV4 = `${IPV4_OCTET}(?:\\.${IPV4_OCTET}){3}`;
const IPV6 = '\\[[0-9a-f:.]+\\]';
const DOMAIN_LABEL =
  '[a-z\\u00a1-\\uffff0-9](?:[a-z\\u00a1-\\uffff0-9-]{0,61}[a-z\\u00a1-\\uffff0-9])?';
const DOMAIN_MIDDLE = '(?:\\.(?!-)[a-z\\u00a1-\\uffff0-9-]{1,63}(?<!-))*';
const DOMAIN_TLD =
  '\\.(?!-)(?:[a-z\\u00a1-\\uffff-]{2,63}|xn--[a-z0-9]{1,59})(?<!-)';
const DOMAIN = `${DOMAIN_LABEL}${DOMAIN_MIDDLE}${DOMAIN_TLD}\\.?`;

const HOSTNAME_REGEX = new RegExp(
  `^(?:${IPV4}|${IPV6}|${DOMAIN}|localhost)$`,
  'i',
);

const isValidUrl = (value: string): boolean => {
  try {
    const url = new URL(value);
    if (!ALLOWED_SCHEMES.includes(url.protocol)) return false;
    return HOSTNAME_REGEX.test(url.hostname);
  } catch {
    return false;
  }
};

export default isValidUrl;
